









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ChickenStable extends Vue {
  @Prop({ default: 5 }) private width!: number
  @Prop({ default: 5 }) private height!: number
  @Prop({ default: -2 }) private left!: number
  @Prop({ default: -2.5 }) private top!: number
  @Prop({ default: null }) private bottom!: number
  @Prop({ default: 6 }) private minWidth!: number
}
